import { Link , useNavigate} from "react-router-dom";

import { Space, Breadcrumb, Button, message } from "antd";
import type { ColumnsType } from "antd/es/table";
import { PageHeader } from "@ant-design/pro-layout";

import {
   Site, UserData
} from "../../model/model";
import SessionStore from "../../model/SessionStore";

import type { GetPageCallbackFunc } from "../../components/DataTable";
import DataTable from "../../components/DataTable";

interface IProps {
  site: Site;
}

function ListSiteUsers(props: IProps) {
  const navigate = useNavigate();
  const [messageApi, contextHolder] = message.useMessage();
  const columns: ColumnsType<UserData> = [
    {
      title: "name",
      dataIndex: "name",
      key: "name",
      render: (text, record) => <Link to={`/site/${props.site.id}/user/${record.login}/edit`}>{text}</Link>,
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      render: (text, record) => {
          return record.name;
      },
    },
  ];

  const getPage = (limit: number, offset: number, callbackFunc: GetPageCallbackFunc) => {
    const siteId :string = props.site.id;
    SessionStore.getClient().getSiteUsers(siteId, SessionStore.getBearer()).then( (resp) => {
          callbackFunc(resp.data.length, resp.data);
    }).catch(err=>{
      if(err.status == 401){
          navigate(`/login`);
        }else{
          messageApi.open({
            type: 'error',
            content: err.message,
          });
        }
    });
  };

  return (
    <Space direction="vertical" style={{ width: "100%" }} size="large">
      <PageHeader
        breadcrumbRender={() => (
          <Breadcrumb>
            <Breadcrumb.Item>
              <span>Sites</span>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <span>
                <Link to={`/site/${props.site.id}`}>{props.site.name}</Link>
              </span>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <span>Site users</span>
            </Breadcrumb.Item>
          </Breadcrumb>
        )}
        title="Site users"
        extra={[
            <Button type="primary">
              <Link to={`/site/${props.site.id}/users/create`}>Add site user</Link>
            </Button>
        ]}
      />
      <DataTable columns={columns} getPage={getPage} rowKey="id" />
    </Space>
  );
}

export default ListSiteUsers;
